<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <fullscreen :id="elementId" class="wrapper" ref="fullscreen" @change="fullscreenChange" background="#ffffff">
            <LineChart :styles="chartStyles" :chart-data="chartData.data" :options="chartData.options"/>
            <button v-if="!saving" type="button" class="btn btn-default btn-map-fullscreen" @click="toggleFullScreen">
                <i class="mdi" :class="[fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen']"/>
            </button>
        </fullscreen>
    </div>
</template>

<script>
    import LineChart from './line-chart.js'
    import Fullscreen from 'vue-fullscreen/src/component.vue'

    export default {
        name: 'trending-pupillogram-graph',
        components:
        {
            LineChart,
            Fullscreen
        },
        data: function ()
        {
            return {
                chartData: {},
                fullscreen: false,
                itemsPerPageOptions: [4, 8, 12],
                itemsPerPage: 4,
            }
        },
        props:
        {
            pupillogramTests: {},
            saving: false,
            elementId: ''
        },
        computed:
        {
            chartStyles()
            {
                return {
                    height: '100%',
                    width: '100%'
                }
            }
        },
        watch:
        {
            pupillogramTests()
            {
                this.chartDataCommon()
            }
        },
        mounted()
        {
            this.chartDataCommon()
        },
        methods:
        {
            toggleFullScreen()
            {
                this.$refs.fullscreen.toggle()
            },
            fullscreenChange (fullscreen)
            {
                this.fullscreen = fullscreen
            },
            chartDataCommon ()
            {
                let xData = [];

                let index;
                for (index = 0; index < this.pupillogramTests.maxPupillogramLength; ++index)
                {
                    xData.push((index * 0.033333333333).toFixed(2))
                }

                this.chartData =
                {
                    type: 'line',
                    data:
                    {
                        labels: xData,
                        datasets: []
                    },
                    options:
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales:
                        {
                            yAxes:
                            [
                                {
                                    ticks:
                                    {
                                        beginAtZero: false
                                    },
                                    scaleLabel:
                                    {
                                        display: true,
                                        labelString: 'Pupil Diameter (mm)'
                                    }
                                }
                            ],
                            xAxes:
                            [
                                {
                                    ticks:
                                    {
                                        maxTicksLimit: 30
                                    },
                                    scaleLabel:
                                    {
                                        display: true,
                                        labelString: 'Time (seconds)'
                                    }
                                }
                            ]
                        },
                        title:
                        {
                            display: true,
                            text: 'Pupillogram',
                            fontSize: 20
                        }
                    }
                };
                let spliceIndex = 0;
                if (this.pupillogramTests.rightBaseline)
                {
                    this.chartData.data.datasets.splice(spliceIndex, 0,
                    {
                        label: 'Right Baseline',
                        data: this.pupillogramTests.rightBaseline,
                        backgroundColor: '#0d47a1',
                        borderColor: '#0d47a1',
                        fill: false,
                        borderWidth: 1
                    });
                    spliceIndex++
                }
                if (this.pupillogramTests.leftBaseline)
                {
                    this.chartData.data.datasets.splice(spliceIndex, 0,
                    {
                        label: 'Left Baseline',
                        data: this.pupillogramTests.leftBaseline,
                        backgroundColor: '#7c4dff',
                        borderColor: '#7c4dff',
                        fill: false,
                        borderWidth: 1
                    });
                    spliceIndex++
                }
                const pupillogramCount = this.pupillogramTests.items.length;
                for (let pupillogramIndex = 0; pupillogramIndex < pupillogramCount; ++pupillogramIndex)
                {
                    let yData = [];
                    for (index = 0; index < this.pupillogramTests.items[pupillogramIndex].item.length; ++index)
                    {
                        // Do not include any values that are 0 which indicates a blink
                        // This should only happen at the start or end, the middle should have interpolated values
                        if (this.pupillogramTests.items[pupillogramIndex].item[index] !== 0)
                        {
                            yData.push(+(Math.round(this.pupillogramTests.items[pupillogramIndex].item[index] + 'e+3') + 'e-3'))
                        }
                        else // Show 0 data as empty
                        {
                            yData.push(null)
                        }
                    }
                    this.chartData.data.datasets.splice(spliceIndex, 0,
                    {
                        label: `${this.pupillogramTests.items[pupillogramIndex].rightEye ? 'Right' : 'Left'} Pupil Diameter ${this.pupillogramTests.items[pupillogramIndex].index}`,
                        data: yData,
                        backgroundColor: this.pupillogramTests.items[pupillogramIndex].color,
                        borderColor: this.pupillogramTests.items[pupillogramIndex].color,
                        fill: false,
                        borderWidth: 1
                    });
                    spliceIndex++
                }
            }
        }
    };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .wrapper {
        position: relative;
        height: 450px;

        .btn-map-fullscreen {
            position: absolute;
            right: 1px;
            top: 1px;
            width: 36px;
            height: 36px;
            padding: 0;
            font-size: 36px;
            line-height: 36px;
            text-align: center;
            outline: none;
        }

        &.fullscreen {
            .btn-map-fullscreen {
                right: 1px;
                top: 1px;
            }
        }
    }
</style>